import React, { useState } from "react";
import { Slider } from "@/components/ui/slider";

const fmt2 = (n) => Number(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const PositionCard = ({ pos, active, index, t, livePnl, onClosePartial, onAdd, onFlip, onClose }) => {
  const [pct, setPct] = useState(75);
  const [addP, setAddP] = useState(25);
  const pnl = livePnl != null ? livePnl : pos.pnl;
  const pnlPct = pos.amount > 0 ? (pnl / pos.amount) * 100 : 0;
  const up = pnl >= 0;

  return (
    <div data-testid={`position-row-${index}`} className="border border-white/10 bg-panelhover/40 rounded-sm p-3">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <span className="font-mono font-bold">{pos.symbol}</span>
          <span className={`font-mono text-[10px] px-1.5 py-0.5 rounded ${pos.side === "buy" ? "bg-profit/20 text-profit" : "bg-loss/20 text-loss"}`}>
            {pos.side.toUpperCase()}
          </span>
        </div>
        <div className="text-right">
          <span className={`font-mono font-bold tabular-nums ${up ? "text-profit" : "text-loss"}`}>
            {up ? "+" : ""}{fmt2(pnl)}
          </span>
          <span data-testid={`pnl-pct-${index}`} className={`font-mono text-[11px] ml-2 tabular-nums ${up ? "text-profit" : "text-loss"}`}>
            ({up ? "+" : ""}{pnlPct.toFixed(2)}%)
          </span>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-2 font-mono text-[11px] mb-3">
        <div><div className="text-white/30 uppercase tracking-wide">{t("amount")}</div><div className="text-white/80 tabular-nums">{fmt2(pos.amount)}</div></div>
        <div><div className="text-white/30 uppercase tracking-wide">{t("entry")}</div><div className="text-white/80 tabular-nums">{fmt2(pos.entry_price)}</div></div>
        <div><div className="text-white/30 uppercase tracking-wide">{t("value")}</div><div className="text-white/80 tabular-nums">{fmt2(pos.value)}</div></div>
      </div>
      {active && (
        <>
          <div className="flex flex-wrap gap-1.5 mb-3">
            <button data-testid={`close-partial-25-${index}`} onClick={() => onClosePartial(pos.index, 25)}
              className="px-2.5 py-1.5 border border-loss/40 text-loss hover:bg-loss/10 rounded-sm text-[11px] font-mono transition-colors">−25%</button>
            <button data-testid={`close-partial-50-${index}`} onClick={() => onClosePartial(pos.index, 50)}
              className="px-2.5 py-1.5 border border-loss/40 text-loss hover:bg-loss/10 rounded-sm text-[11px] font-mono transition-colors">−50%</button>
            <button data-testid={`add-size-25-${index}`} onClick={() => onAdd(pos.index, 25)}
              className="px-2.5 py-1.5 border border-profit/40 text-profit hover:bg-profit/10 rounded-sm text-[11px] font-mono transition-colors">+25%</button>
            <button data-testid={`add-size-50-${index}`} onClick={() => onAdd(pos.index, 50)}
              className="px-2.5 py-1.5 border border-profit/40 text-profit hover:bg-profit/10 rounded-sm text-[11px] font-mono transition-colors">+50%</button>
            <button data-testid={`flip-pos-${index}`} onClick={() => onFlip(pos.index)}
              className="px-2.5 py-1.5 border border-signal/40 text-signal hover:bg-signal/10 rounded-sm text-[11px] font-mono uppercase tracking-wide transition-colors">{t("flip")}</button>
            <button data-testid={`close-pos-${index}`} onClick={() => onClose(pos.index)}
              className="px-2.5 py-1.5 border border-white/20 text-white/70 hover:bg-white/5 rounded-sm text-[11px] font-mono uppercase tracking-wide transition-colors ml-auto">{t("close")}</button>
          </div>
          <div className="flex items-center gap-3 pt-2 border-t border-white/5">
            <Slider
              data-testid={`close-slider-${index}`}
              value={[pct]} min={1} max={100} step={1}
              onValueChange={(v) => setPct(v[0])}
              className="flex-1"
            />
            <span className="font-mono text-xs text-white/60 w-10 text-right tabular-nums">{pct}%</span>
            <button
              data-testid={`close-custom-${index}`}
              onClick={() => onClosePartial(pos.index, pct)}
              className="px-3 py-1.5 border border-loss/50 text-loss hover:bg-loss/10 rounded-sm text-[11px] font-mono uppercase tracking-wide transition-colors whitespace-nowrap"
            >
              {t("close")} {pct}%
            </button>
          </div>
          <div className="flex items-center gap-3 pt-2 mt-2 border-t border-white/5">
            <Slider
              data-testid={`add-slider-${index}`}
              value={[addP]} min={1} max={100} step={1}
              onValueChange={(v) => setAddP(v[0])}
              className="flex-1"
            />
            <span className="font-mono text-xs text-white/60 w-10 text-right tabular-nums">{addP}%</span>
            <button
              data-testid={`add-custom-${index}`}
              onClick={() => onAdd(pos.index, addP)}
              className="px-3 py-1.5 border border-profit/50 text-profit hover:bg-profit/10 rounded-sm text-[11px] font-mono uppercase tracking-wide transition-colors whitespace-nowrap"
            >
              {t("add_label")} {addP}%
            </button>
          </div>
        </>
      )}
    </div>
  );
};
